let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dn1MT")).then(() => parcelRequire('k1l5g'));